import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Tab from '../../../components/Tab';
import Menu from '../../../components/Menu';
import HasRole from '../../../components/HasRole';
import messages from '../messages';
import PremiumMenuItem from '../Edit/PremiumMenu/premiumMenuItem';
import PremiumHemSubscription from '../../../components/PremiumHemSubscription';
import LinksDropdown from '../Edit/PremiumMenu/linksDropdown';
import PremiumFeatureButton from '../Edit/PremiumMenu/premiumFeatureButton';
import ProfilesDropdown from '../Edit/PremiumMenu/profilesDropdown';

import * as constants from '../../Authorization/constants';
import '../styles.css';

const LinksAndProfilesMenu = ({
  onShowAddLinkModal,
  toggleUpgradeFormVisibility,
  onShowAddProfileModal,
}) => (
  <Tab.Pane attached={false}>
    <Menu vertical styleName="editor-menu">
      <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
        <PremiumHemSubscription>
          <LinksDropdown onShowAddLinkModal={onShowAddLinkModal} />
        </PremiumHemSubscription>
        <PremiumHemSubscription inactive>
          <Menu.Item as="li" styleName="editor-menu-item" link>
            <FormattedMessage {...messages.linksMenuItem} />
            <PremiumFeatureButton
              styles="premium-feature-button"
              onClick={toggleUpgradeFormVisibility}
            />
          </Menu.Item>
        </PremiumHemSubscription>
      </HasRole>
      <PremiumHemSubscription>
        <ProfilesDropdown onShowAddProfileModal={onShowAddProfileModal} />
      </PremiumHemSubscription>
      <PremiumHemSubscription inactive>
        <PremiumMenuItem
          onPremiumFeatureClick={toggleUpgradeFormVisibility}
          menuTitle={messages.profileMenuItem}
        />
      </PremiumHemSubscription>
    </Menu>
  </Tab.Pane>
);

LinksAndProfilesMenu.propTypes = {
  onShowAddLinkModal: PropTypes.func,
  toggleUpgradeFormVisibility: PropTypes.func,
  onShowAddProfileModal: PropTypes.func,
};

export default LinksAndProfilesMenu;
